// NEXUS LUXE PRO - LD SIGNATURE VIDEO SLIDER MOTION ENGINE

document.addEventListener('DOMContentLoaded', () => {
  class LDSignatureSlider {
    constructor(section) {
      this.section = section;
      this.slides = section.querySelectorAll('.ld-signature-video-slide');
      this.dots = section.querySelectorAll('.slider-dot');
      this.prevBtn = section.querySelector('.slider-control--prev');
      this.nextBtn = section.querySelector('.slider-control--next');
      this.autoplaySpeed = parseInt(section.dataset.autoplaySpeed) || 5000;
      this.currentIndex = 0;
      this.timer = null;

      this.init();
    }

    init() {
      if (this.slides.length === 0) return;

      // Ensure first slide is active immediately
      this.goToSlide(0);

      if (this.slides.length < 2) return;

      this.startAutoplay();

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.stopAutoplay();
          this.prevSlide();
          this.startAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.stopAutoplay();
          this.nextSlide();
          this.startAutoplay();
        });
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.stopAutoplay();
          this.goToSlide(index);
          this.startAutoplay();
        });
      });

      // Handle visibility
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });
    }

    goToSlide(index) {
      // Remove active from all
      this.slides.forEach(slide => {
        slide.classList.remove('is-active');
        const video = slide.querySelector('video');
        if (video && !video.paused) {
          // Pause others but keep first frame ready? No, keep running or pause to save resource
          // video.pause(); 
        }
      });

      this.dots.forEach(dot => dot.classList.remove('is-active'));

      // Update index
      this.currentIndex = index;
      if (this.currentIndex >= this.slides.length) this.currentIndex = 0;
      if (this.currentIndex < 0) this.currentIndex = this.slides.length - 1;

      // Add active to new
      const currentSlide = this.slides[this.currentIndex];
      currentSlide.classList.add('is-active');

      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('is-active');
      }

      // Play video if present
      const video = currentSlide.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(e => console.log('Autoplay prevented:', e));
      }
    }

    nextSlide() {
      this.goToSlide(this.currentIndex + 1);
    }

    prevSlide() {
      this.goToSlide(this.currentIndex - 1);
    }

    startAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.nextSlide();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  // Initialize all sliders
  const initSliders = () => {
    const sections = document.querySelectorAll('.ld-signature-video-slider');
    sections.forEach(s => new LDSignatureSlider(s));
  };

  initSliders();

  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', initSliders);
});